/** Hierarchical query-key factory (ARCHITECTURE §3.4). */
export const groupKeys = {
  all: () => ['group'] as const,
  lists: () => [...groupKeys.all(), 'list'] as const,
  list: () => [...groupKeys.lists()] as const,
  detail: (id: string) => [...groupKeys.all(), 'detail', id] as const,
} as const;
